module.exports = __webpack_public_path__ + "thumbnail-237e393b1ddbbd8f328539b7c57293ea.png";